import { render, staticRenderFns } from "./detail_card_m.vue?vue&type=template&id=a6e84130&scoped=true&"
var script = {}
import style0 from "./detail_card_m.vue?vue&type=style&index=0&id=a6e84130&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e84130",
  null
  
)

export default component.exports